// Browse module icon barrel (BACKLOG A-4).
// Re-exports from @tabler/icons (already installed): 24x24 viewBox,
// currentColor stroke, round linecaps. Defaults match the design handoff
// sizes/strokes (search 15/2.2, chevron-down 10/3, calendar 12/2);
// override via props if a context needs different sizing.
import React from 'react';
import { IconSearch, IconChevronDown, IconCalendar, IconBell, IconTrendingUp, IconX } from '@tabler/icons';

export const SearchIcon = (props) => <IconSearch size={15} stroke={2.2} {...props} />;
export const ChevronDownIcon = (props) => <IconChevronDown size={10} stroke={3} {...props} />;
export const CalendarIcon = (props) => <IconCalendar size={12} stroke={2} {...props} />;
// SOR-625 mobile: bell on the upcoming-row reminder button, X closes the
// expanded mobile search.
export const BellIcon = (props) => <IconBell size={20} stroke={2} {...props} />;
export const CloseIcon = (props) => <IconX size={18} stroke={2.2} {...props} />;
// Rising badge (design review 2026-08-02): angular trending-up arrow — icon
// geometry + amber hue are the two separation channels from the LIVE badge.
export const RisingIcon = (props) => <IconTrendingUp size={12} stroke={2.4} {...props} />;
